<div class="common-popup">
  <!-- Modern Integrated Header -->
  <div class="popup-header">
    <div class="popup-header-main">
      <div class="popup-header-icon" [ngClass]="headerIconBg">
        <i [class]="headerIcon"></i>
      </div>
      <div class="header-title-group">
        <h3 class="title">{{ headerTitle }}</h3>
        <span class="subtitle" *ngIf="data?.subTitle">{{ data.subTitle }}</span>
      </div>
    </div>
    <button type="button" class="popup-close-btn" (click)="close()" aria-label="Close" title="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- Dialog Body Content -->
  <div class="body common-popup-content">
    <ng-container *ngIf="data?.template; else htmlContent">
      <ng-container *ngTemplateOutlet="data.template; context: data.context"></ng-container>
    </ng-container>
    <ng-template #htmlContent>
      <div [innerHTML]="data?.html || ''"></div>
    </ng-template>
  </div>

  <!-- Fallback Actions Footer -->
  <div class="footer" *ngIf="data?.actions?.length">
    <button type="button" *ngFor="let a of data.actions"
      class="saas-popup-action-btn"
      (click)="a.handler ? a.handler() : close(a.value)">
      {{ a.label }}
    </button>
  </div>
</div>